module.exports = "<a [routerLink]=\"previousUrl\">\n    <i class=\"fa fa-angle-left\"></i>\n    {{ 'app.shared.labels.back' | translate }}\n</a>\n"